// version-check.js — browser-only, no React/Rill coupling
// Detects when a newer release (package.json version) is deployed and offers
// a one-click reload. The version compared is RELEASE_VERSION (not GIT_VERSION)
// so that ordinary commits never trigger the toast — only release deploys, which
// bump the package.json version, do.

const CURRENT = process.env.RELEASE_VERSION;
const CHECK_INTERVAL_MS = 60_000;

let lastChecked = 0;
let toastShown = false;

function showUpdateToast() {
  if (toastShown) return;
  toastShown = true;

  const banner = document.createElement("div");
  Object.assign(banner.style, {
    position: "fixed",
    bottom: "24px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: "9999",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    background: "#1a1a1a",
    color: "#fff",
    padding: "12px 20px",
    borderRadius: "8px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
    fontSize: "14px",
    fontFamily: "inherit",
    whiteSpace: "nowrap",
  });

  const text = document.createTextNode("New version available");
  const btn = document.createElement("button");
  btn.textContent = "Reload";
  btn.setAttribute("data-button-type", "primary");
  btn.onclick = () => window.location.reload();

  banner.appendChild(text);
  banner.appendChild(btn);
  document.body.appendChild(banner);
}

function onVisibilityChange() {
  if (document.visibilityState !== "visible") return;

  const now = Date.now();
  if (now - lastChecked < CHECK_INTERVAL_MS) return;
  lastChecked = now;

  fetch(`/version.json?t=${now}`, { cache: "no-store" })
    .then((r) => r.json())
    .then(({ version }) => {
      if (version && version !== CURRENT) {
        document.removeEventListener("visibilitychange", onVisibilityChange);
        showUpdateToast();
      }
    })
    .catch(() => {
      // swallow — never let network errors surface into focus handling
    });
}

export function initVersionCheck() {
  // Bail out if no version was baked in (e.g. a bundle not built by webpack.common).
  if (!CURRENT) return;

  document.addEventListener("visibilitychange", onVisibilityChange);
}
